import Vue from "vue";
import VueRouter from "vue-router";
import {
    post
} from "../lib/axios";
import global from "../lib/global.vue";

Vue.use(VueRouter);

if (process.env.NODE_ENV == "development") {
    // localStorage.clear()
    // localStorage.setItem("token", "58455ac1dfe77bc136f2ce932ff51b6"); // 溪风
    // localStorage.setItem("token", "58455ac1dfe77bc136f2ce932ff51bf6"); // 溪风
}

const Routers = [{
        path: '*',
        name: 'appointment',
        meta: {
            title: "实验室设备预约",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointment'], resolve)
    },
    {
        path: '/',
        name: 'appointment',
        meta: {
            title: "实验室设备预约",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointment'], resolve)
    }, {
        path: '/login',
        name: 'login',
        meta: {
            title: "登录",
            keepAlive: false,
            backgroundColor: '#ffffff'
        },
        component: resolve => require(['@/views/login'], resolve)
    },
    {
        path: '/mine',
        name: 'mine',
        meta: {
            title: "个人中心",
            keepAlive: true,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/mine'], resolve)
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        meta: {
            title: "修改密码",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/changePassword'], resolve)
    },
    {
        path: '/jurisdiction',
        name: 'jurisdiction',
        meta: {
            title: "权限暂未开放",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/jurisdiction'], resolve)
    },
    {
        path: '/appointment',
        name: 'appointment',
        meta: {
            title: "实验室设备预约",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointment'], resolve)
    },
    {
        path: '/appointmentDetails',
        name: 'appointmentDetails',
        meta: {
            title: "实验室预约详情",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointmentDetails'], resolve)
    },
    {
        path: '/appointmentApply',
        name: 'appointmentApply',
        meta: {
            title: "实验室预约申请",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointmentApply'], resolve)
    },
    {
        path: '/record',
        name: 'record',
        meta: {
            title: "实验室设备预约记录",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/record'], resolve)
    },
    {
        path: '/appointInformation',
        name: 'appointInformation',
        meta: {
            title: "设备预约记录信息",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/appointInformation'], resolve)
    },
    {
        path: '/approval',
        name: 'approval',
        meta: {
            title: "实验室设备预约审批",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/approval'], resolve)
    },
    {
        path: '/approvalDetails',
        name: 'approvalDetails',
        meta: {
            title: "实验室设备预约审批",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/laboratory/approvalDetails'], resolve)
    },



    {
        path: '/room_appointment',
        name: 'room_appointment',
        meta: {
            title: "会议室预约",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/appointment'], resolve)
    },
    {
        path: '/room_appointmentDetails',
        name: 'room_appointmentDetails',
        meta: {
            title: "会议室预约详情",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/appointmentDetails'], resolve)
    },
    {
        path: '/room_appointmentApply',
        name: 'room_appointmentApply',
        meta: {
            title: "会议室预约申请",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/appointmentApply'], resolve)
    },
    {
        path: '/room_record',
        name: 'room_record',
        meta: {
            title: "会议室预约记录",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/record'], resolve)
    },
    {
        path: '/room_appointInformation',
        name: 'room_appointInformation',
        meta: {
            title: "会议室预约记录信息",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/appointInformation'], resolve)
    },
    {
        path: '/room_approval',
        name: 'room_approval',
        meta: {
            title: "会议室预约审批",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/approval'], resolve)
    },
    {
        path: '/room_approvalDetails',
        name: 'room_approvalDetails',
        meta: {
            title: "会议室预约审批详情",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/room/approvalDetails'], resolve)
    },

    {
        path: '/lab_inform',
        name: 'lab_inform',
        meta: {
            title: "实验设备信息管理",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/asset/lab_inform'], resolve)
    },
    {
        path: '/equipment_inform',
        name: 'equipment_inform',
        meta: {
            title: "实验室信息管理",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/asset/equipment_inform'], resolve)
    },
    {
        path: '/room_inform',
        name: 'room_inform',
        meta: {
            title: "会议室信息管理",
            keepAlive: false,
            backgroundColor: '#F8F8F8'
        },
        component: resolve => require(['@/views/asset/room_inform'], resolve)
    },

];

const RouterConfig = {
    base: "",
    // mode: "hash",
    mode: 'history',
    routes: Routers
};
const router = new VueRouter(RouterConfig);
router.beforeEach((to, from, next) => {
    console.log('from.meta.isLogin===>', from);
    // if (!from.meta.isLogin && from.path != '/') {
    //     console.log(123);
    //     next();
    //     return;
    // }
    if (to.path === '/login') {
        next()
    } else {
        if (localStorage.getItem('token')) {
            next()
        } else {
            next({
                path: '/login'
            })
        }
    }

    // return;
    // let href = window.location.href;
    // console.log('当前路径', href);
    // let token = localStorage.getItem("token") // 获取本地存储token

    // if (!!token) {
    //     if (href.indexOf('/#/') == -1) {
    //         if (href.includes("com/share?")) {
    //             localStorage.setItem("shareType", '1');
    //             if (href.includes("from")) {
    //                 let urlLeft = href.indexOf("path=/")
    //                 let urlRight = href.indexOf("/&")
    //                 console.log('urlRight===>', urlRight);
    //                 let newUrlName = href.substring(urlLeft + 6, urlRight);
    //                 let newUrl = global.WEB_URL + '#/' + newUrlName + '?' + href.substring(urlRight + 2, href.indexOf("&from="))
    //                 console.log('newUrl==>', newUrl);

    //                 // setTimeout(() => {
    //                 window.location.href = newUrl
    //                     // }, 10000);
    //                 return;
    //             } else {
    //                 let urlLeft = href.indexOf("path=/")
    //                 let urlRight = href.indexOf("/&")
    //                 console.log('urlRight===>', urlRight);
    //                 let newUrlName = href.substring(urlLeft + 6, urlRight);
    //                 console.log('newUrlName==>', newUrlName);
    //                 let newUrl = global.WEB_URL + '#/' + newUrlName + '?' + href.substring(urlRight + 2, href.indexOf("#/"))
    //                 console.log('newUrl==>', newUrl);
    //                 // setTimeout(() => {
    //                 window.location.href = newUrl
    //                     // }, 10000);
    //                 return;
    //             }
    //         }
    //         let index = href.indexOf('#/');
    //         let newUrl = href.substring(index);
    //         console.log('global.WEB_URL + newUrl===>', global.WEB_URL + newUrl);
    //         // setTimeout(() => {
    //         window.location.href = global.WEB_URL + newUrl
    //             // }, 10000);
    //         return;
    //     }
    //     localStorage.removeItem('goBackUrl')
    //     if (from.path == '/home') {
    //         console.log(1);
    //         next();
    //         return;
    //     }
    //     if (from.path == '/') {
    //         console.log(1);
    //         next();
    //         return;
    //     }
    //     console.log(2);
    //     next();
    //     return;
    // }
    // if (href.includes("type=bind")) {
    //     let leftIndex = href.indexOf("userId");
    //     let rightIndex = href.indexOf("&type=bind");
    //     let newdata = href.substring(leftIndex + 7, rightIndex);
    //     console.log('newData1===>', newdata);
    //     localStorage.setItem('share_id', newdata);
    //     // setTimeout(() => {
    //     window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + global.APPID + "&redirect_uri=" + global.WEB_URL + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
    //     // }, 10000);
    //     return;
    // }

    // if (href.includes("?code")) {
    //     let urlLeftIndex = href.indexOf("code=") + 5; //获取域名结束的位置
    //     let urlRightIndex = href.indexOf("&state"); //获取域名结束的位置
    //     let code = href.substring(urlLeftIndex, urlRightIndex); //url右侧部分
    //     let data = {
    //         code: code,
    //     };
    //     if (!!localStorage.getItem('share_id')) {
    //         data.pid = localStorage.getItem('share_id')
    //     }
    //     post("/wechat/wechat/login", data)
    //         .then(res => {
    //             if (res.code == 1) {
    //                 let backUrl = localStorage.getItem('goBackUrl')
    //                 localStorage.setItem("token", res.data.token);
    //                 localStorage.removeItem('share_id')
    //                     // setTimeout(() => {
    //                 if (!backUrl) {
    //                     window.location.href = global.WEB_URL
    //                     return;
    //                 }
    //                 window.location.href = backUrl
    //                     // }, 10000);
    //             }
    //         })
    //         .catch(err => {});
    //     return;
    // } else {
    //     if (href.includes("com/share?")) {
    //         localStorage.setItem("shareType", '1');
    //         if (href.includes("from")) {
    //             let urlLeft = href.indexOf("path=/")
    //             let urlRight = href.indexOf("/&")
    //             let newUrlName = href.substring(urlLeft + 6, urlRight);
    //             let newUrl = global.WEB_URL + '#/' + newUrlName + '?' + href.substring(urlRight + 2, href.indexOf("&from="))
    //             localStorage.setItem("goBackUrl", newUrl);
    //         } else {
    //             let urlLeft = href.indexOf("path=/")
    //             let urlRight = href.indexOf("/&")
    //             let newUrlName = href.substring(urlLeft + 6, urlRight);
    //             let newUrl = global.WEB_URL + '#/' + newUrlName + '?' + href.substring(urlRight + 2, href.indexOf("#/"))
    //             localStorage.setItem("goBackUrl", newUrl);
    //         }
    //     } else {
    //         localStorage.setItem("goBackUrl", window.location.href);
    //     }

    //     // setTimeout(() => {
    //     window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + global.APPID + "&redirect_uri=" + global.WEB_URL + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
    //     // }, 5000);
    //     return;
    // }
});
router.afterEach(() => {
    window.scrollTo(0, 0);
});

export default router;